<template>
    <Teleport :to="`#search-engine-top-${ screenWidth < 991 ? 'mobile': 'desktop' }`">
        <div class="search-engine-top">
            <div class="search-engine-top__inner" style="transition: 3s linear width;">
                <svg @click="handleOpen($event)" class="search-engine-top__icon">
                    <use xlink:href="#svg-magnifying"></use>
                </svg>
                <transition
                    name="show"
                    @enter="enter"
                    @leave="leave"
                    :css="false"
                >
                    <div v-if="openItems" class="search-engine-top__nav">
                        <input
                            type="text"
                            class="search-engine-top__input"
                            @input="handlerInput($event)"
                            :placeholder="result.placeholder"
                            @keyup.enter="goSearchCatalog"
                        >
                        <svg @click="handleOpen($event)" class="search-engine-top__close">
                            <use xlink:href="#svg-close"></use>
                        </svg>
                    </div>
                </transition>
                <transition name="fade">
                    <div v-if="response && response.products && openItems && response.products.items" class="search-engine-top__response">
                        <PerfectScrollbar class="search-engine-top__elements">
                            <!--                        <div class="search-engine-top__top">-->
                            <!--                            <h6 class="search-engine-top__title">Шукати в категорії (нужны данные)</h6>-->
                            <!--                            <a href="javascript:void(0)" class="search-engine-top__category">-->
                            <!--                                Каблучки з <span class="search-engine-top__blue">перлинами (нужны данные)</span>-->
                            <!--                            </a>-->
                            <!--                            <a href="javascript:void(0)" class="search-engine-top__category">-->
                            <!--                                Сережки з <span class="search-engine-top__blue">перлинами (нужны данные)</span>-->
                            <!--                            </a>-->
                            <!--                            <a href="javascript:void(0)" class="search-engine-top__category">-->
                            <!--                                Кулони з <span class="search-engine-top__blue">перлинами (нужны данные)</span>-->
                            <!--                            </a>-->
                            <!--                            <a href="javascript:void(0)" class="search-engine-top__category">-->
                            <!--                                Аксесуари з <span class="search-engine-top__blue">перлинами (нужны данные)</span>-->
                            <!--                            </a>-->
                            <!--                        </div>-->
                            <!--                        {{response.products && response.products.items}}-->
                            <div v-if="response.products && response.products.items" class="search-engine-top__middle">
                                <h6 v-if="response.messages && response.messages.sectionsTitle" class="search-engine-top__title">
                                    {{response.messages.sectionsTitle}}
                                </h6>
                                <div class="search-engine-top__sections">
                                    <p class="search-engine-top__section" v-for="section in this.showItemInSection()">{{ section.NAME }} {{ response.messages.to }} <a :href="section.URl">{{response.query}}</a></p>
                                </div>
                            </div>
                            <div v-if="response.products && response.products.items" class="search-engine-top__middle">
                                <h6 v-if="response.messages && response.messages.itemsTitle" class="search-engine-top__title">
                                    {{response.messages.itemsTitle}}
                                </h6>
                                <div class="search-engine-top__items">

                                    <div class="search-engine-top__item" v-for="item in response.products.items">
                                        <a :href="item.detailPage" class="search-engine-top__image">
                                            <img v-if="item.picture" :src="item.picture.src" :alt="item.picture.alt">
                                        </a>
                                        <div class="search-engine-top__description">
                                            <a :href="item.detailPage" class="def-title-6" v-html="item.name"></a>
                                            <div>
                                            <span v-if="item.price" class="def-price">
                                                {{item.price.printPrice || item.price.price}}
                                            </span>
                                                <span v-if="item.price && item.price.price && item.price.priceOld
                                                        && +item.price.price !== +item.price.priceOld"
                                                      class="def-price-old">
                                                {{ item.price.printPriceOld }}
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </PerfectScrollbar>
                        <div v-if="response.products && response.products.items && response.products.items.length"
                             class="search-engine-top__bottom">
                            <a v-if="response.messages && response.messages.allResults"
                               :href="response.url"
                               class="def-button" >{{response.messages.allResults}}</a>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </Teleport>
</template>

<script>
    export default {
        name: 'search-engine-top',
        props: {
            result: {
                type: Object,
                default: () => ({
                    "ajax": {
                        "url":"/ajax.php",
                        "data": {
                            "action":"search",
                            "ajax":"y",
                            "lang":"ru",
                            "q":"safd"
                        },
                        "searchName":"q",
                        "delay":100
                    },
                    "placeholder":"Поиск"
                })
            },
            className: {
                type: 'String',
            },
        },
        data() {
            return {
                response: {},
                value: '',
                timeout: '',
                openItems: false,
                inputAnimationWidth: 0,
                inputAnimationStep: 0,
            };
        },
        methods: {
            handlerInput(e) {
                const result = this.result;
                let delay = 1000;
                if (result && result.ajax && result.ajax.searchName) {
                    delay = result.ajax.searchName;
                }
                this.value = e.target.value;
                clearTimeout(this.timeout);
                this.timeout = setTimeout(this.getSearchElements.bind(this), delay);
            },
            async getSearchElements() {
                try {
                    const result = this.result;

                    if (result && result.ajax && result.ajax.url && result.ajax.searchName && this.value !=='') {
                        let data = result.ajax.data;
                        data[result.ajax.searchName] = this.value;
                        const response = await axios.get(result.ajax.url, {params: data});
                        this.response = response.data;
                        this.openItems = true;
                        this.handlerClickGtag();
                    } else {
                        this.response = {}
                    }
                } catch (err) {
                    console.error(err);
                }
            },
            handlerClickGtag() {
                try {
                    const product = this.response?.gtag?.data;
                    if (product) {
                        gtag('event', 'add_to_cart', {
                            'send_to': 'AW-440849847',
                            'value': product.value,
                            'items': product.items

                        });
                    }
                } catch (err) {
                    console.error(err);
                }
            },
            handleOpen() {
                if (this.value === '') this.response = {};
                this.openItems = !this.openItems;

                if (this.openItems) {
                    document.addEventListener('click', this.handlerAnotherClick, true);
                } else {
                    document.removeEventListener('click', this.handlerAnotherClick, true);
                    this.response = {}
                }
            },
            handlerAnotherClick({target}) {
                const parent = target.closest('.search-engine-top');
                if (!parent) {
                    this.openItems = false;
                    document.removeEventListener('click', this.handlerAnotherClick);
                }
            },
            inputAnimationEnter(el, done) {
                el.style.width = this.inputAnimationStep + 'px';
                this.inputAnimationStep = this.inputAnimationStep + 7;
                if (this.inputAnimationStep <= this.inputAnimationWidth) {
                    requestAnimationFrame(() => this.inputAnimationEnter(el, done));
                } else {
                    done();
                }
            },
            inputAnimationLeave(el, done) {
                el.style.width = this.inputAnimationStep + 'px';
                this.inputAnimationStep = this.inputAnimationStep - 7;
                if (this.inputAnimationStep > 0) {
                    requestAnimationFrame(() => this.inputAnimationLeave(el, done));
                } else {
                    done();
                }
            },
            enter(el, done) {
                this.inputAnimationWidth = el.clientWidth;
                requestAnimationFrame(() => this.inputAnimationEnter(el, done));
            },
            leave(el, done) {
                requestAnimationFrame(() => this.inputAnimationLeave(el, done));
            },
            goSearchCatalog() {
                window.location.href = this.result.page.href + '?q=' + this.value
            },
            showItemInSection() {
                const sections = this.response.sections.slice(1);
                return sections;
            }
        },
    }
</script>

<style lang="scss" scoped>
    .search-engine-top{
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        width: 20px;
        height: 20px;
        @include point-md{
            margin-right: 24px;
            width: 24px;
            height: 24px;
        }
        //&-mobile{
        //    display: flex;
        //    @include point-lg{
        //        display: none;
        //    }
        //}
        //@include point-lg{
        //    display: flex;
        //    margin-right: 24px;
        //    width: 24px;
        //    height: 24px;
        //}
        //&__mobile{
        //    display: flex;
        //    @include point-lg{
        //        display: none;
        //    }
        //}
        &__middle{
            border-bottom: 1px solid #DFDFDF;
            margin-bottom: 5px;
        }
        &__section{
            font-weight: 500;
            font-size: 16px;
            margin-bottom: 15px;
            a{
                color: #618EAF;
            }
        }
        &__inner{
            display: flex;
            align-items: center;
            position: absolute;
            height: 100%;
            background-color: #fff;
            left: 0;
            z-index: 2;
            @include point-md{
                left: 0;
            }
            @include point-lg{
                right: 0;
                left: unset;
            }
        }
        &__icon{
            width: 20px;
            height: 20px;
            @include point-md{
                width: 24px;
                height: 24px;
            }
            &:hover{
                cursor: pointer;
            }
        }
        &__close{
            width: 16px;
            height: 16px;
            &:hover{
                cursor: pointer;
            }
        }
        &__input{
            border: none;
            width: 100%;
            padding: 5px 10px;
            margin: 5px 8px 5px 0;
        }
        &__nav{
            display: flex;
            align-items: center;
            width: calc(100vw - 100px);
            background-color: #fff;
            @include point-md{
                width: 440px;
            }
            @include point-lg{
                width: 344px;
            }
        }
        &__response{
            position: absolute;
            top: 100%;
            left: 0;
            right: 0;
            z-index: 1;
            border-top: 1px solid #DFDFDF;
            background-color: #fff;
            color: var(--text-colour-primary);
        }
        &__elements{
            padding: 8px 8px 4px;
            background: #F7F8F9;
            max-height: 388px;
            overflow-y: auto;
            @include point-md{
                padding: 16px 24px 4px;
            }
        }
        &__category{
            display: flex;
            margin-bottom: 16px;
        }
        &__title{
            font-size: rem(12);
            line-height: 100%;
            color: #757575;
            margin-bottom: 8px;
        }
        &__blue{
            color: var(--text-colour-secondary);
            margin-left: 3px;
        }
        &__top{
            border-bottom: 1px solid #DFDFDF;
            margin-bottom: 16px;
        }
        &__item{
            display: flex;
            background-color: #fff;
            padding: 8px 0;
            &:not(:last-child) {
                margin-bottom: 4px;
            }
        }
        &__description{
            padding: 0 8px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            @include point-md{
                padding: 0 16px;
            }
        }
        &__bottom{
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0px -4px 5px rgba(47, 76, 120, 0.1);
            padding: 16px 0;
            @include point-md{
                padding: 15px 0;
            }
        }
        &__image{
            img{
                display: block;
                max-width: 60px;
                @include point-md{
                    max-width: 80px;
                }
            }
        }
        .def-title-6{
            font-weight: 500;
            font-size: rem(12);
            line-height: 115%;
            letter-spacing: 0.08em;
            text-transform: uppercase;
            margin-bottom: 8px;
            @include point-md{
                font-size: rem(14);
            }
        }
        .def-price{
            font-size: rem(14);
            @include point-md{
                font-size: rem(16);
            }
        }
        .def-price-old{
            margin-left: 5px;
            font-size: rem(12);
            @include point-md{
                font-size: rem(14);
            }
        }
        .def-button{
            font-weight: 500;
            font-size: rem(14);
            letter-spacing: 0.08em;
            text-transform: uppercase;
            height: 40px;
            @include point-md{
                height: 48px;
            }
        }
    }
</style>